const MASTER_CONFIG_KEY = 'masterConfig'

export const getMasterConfig = () => {
	const raw = localStorage.getItem(MASTER_CONFIG_KEY)
	return raw ? JSON.parse(raw) : undefined
}

export const setMasterConfig = data => {
	localStorage.setItem(MASTER_CONFIG_KEY, JSON.stringify(data))
}

export const removeMasterConfig = () => {
	localStorage.removeItem(MASTER_CONFIG_KEY)
}
